import { Star, Quote, ExternalLink } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { testimonials, REVIEW_COUNT, AVERAGE_RATING } from "@/data/testimonials";

const reviews = testimonials;

export const TestimonialsSection = () => {
  return (
    <section className="py-10 bg-muted/30">
      <div className="max-w-6xl mx-auto px-6">
        {/* Google Rating Badge + Heading */}
        <div className="flex flex-col items-center gap-3 mb-8">
          <a
            href="https://www.google.com/search?q=WTR+Restoration+New+Braunfels"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-card border border-border rounded-full px-5 py-2 shadow-sm hover:shadow-md transition-shadow"
          >
            <img
              src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png"
              alt="Google Reviews logo"
              className="h-5 w-auto"
              width={74}
              height={24}
              loading="lazy"
            />
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-sm font-bold text-foreground">{AVERAGE_RATING.toFixed(1)}</span>
            <span className="text-sm text-muted-foreground">{REVIEW_COUNT} reviews</span>
            <ExternalLink className="w-3.5 h-3.5 text-muted-foreground" />
          </a>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground text-center">
            &nbsp;50+ Five-Star Reviews — Zero Shortcuts
          </h2>
          <p className="text-sm text-muted-foreground mt-1 text-center max-w-xl">
            Central Texas homeowners and insurance adjusters consistently rate WTR Restoration 5.0 across Google, BBB, and HomeAdvisor.
          </p>
        </div>

        {/* Reviews Carousel */}
        <div className="max-w-5xl mx-auto" style={{ contain: 'layout style' }}>
          <Carousel
            opts={{ align: "start", loop: true }}
            className="w-full"
          >
            <CarouselContent>
              {reviews.map((review, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="p-2">
                    <Card className="bg-card border-border h-full">
                      <CardContent className="p-5">
                        <div className="flex items-center mb-3">
                          {[...Array(review.rating)].map((_, i) => (
                            <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                          ))}
                        </div>
                        <p className="text-muted-foreground text-sm mb-4 min-h-[80px]">
                          "{review.text}"
                        </p>
                        <div className="border-t border-border pt-3">
                          <div className="font-semibold text-sm text-foreground">{review.name}</div>
                          <div className="text-xs text-muted-foreground">{review.location}</div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex" />
            <CarouselNext className="hidden md:flex" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};